import { Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, of, throwError } from 'rxjs';

import enUS from 'src/assets/i18n/en-US.json';
import es from 'src/assets/i18n/es.json';

// Los diccionarios van EMBEBIDOS en el bundle — nada de fetch/HttpClient:
// La app es offline-first y el SW cachea assets en modo lazy — si el
// usuario cambiaba de idioma sin conexión (o con red lenta) antes de que
// ese JSON se hubiera pedido alguna vez, la carga fallaba y ngx-translate
// quedaba sin diccionario: se veían las claves crudas hasta recargar con red.
//
// Dos JSON pequeños no justifican una petición: embebidos, el cambio de
// idioma es síncrono y funciona siempre, con o sin conexión.
const TRANSLATIONS: Record<string, TranslationObject> = {
  'en-US': enUS,
  es,
};

@Injectable({ providedIn: 'root' })
export class AppTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<TranslationObject> {
    const translations = TRANSLATIONS[lang];
    return translations
      ? of(translations)
      : throwError(() => new Error(`i18n: idioma no soportado <${lang}>`));
  }
}
